var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Geojson } from 'geojson-parser-js';
import { Ellipsoid } from '@skand/math';
import { FeatureCollection, Polygon, Point, LineString, Coordinate, FeatureProperty, } from 'geojson-parser-js/models/geojson';
class GeoJsonExporter {
    /**
     * Get properties
     *
     * @param annotation
     */
    extractFeatureProperties(annotation) {
        var _a, _b, _c;
        const colorString = annotation.color;
        const properties = [
            new FeatureProperty('name', annotation.name),
            new FeatureProperty('fill', colorString),
            new FeatureProperty('stroke', colorString),
            new FeatureProperty('marker-color', colorString),
            new FeatureProperty('stroke-width', 2),
            new FeatureProperty('fill-opacity', 0.5),
        ];
        for (const field of annotation.fields) {
            if (!field)
                continue;
            const name = field.name;
            const type = field.type;
            let value = null;
            if (field.type === 'URL' && field.urls) {
                value = [];
                for (const url of (_a = field.urls) !== null && _a !== void 0 ? _a : []) {
                    if (url && url.name && url.url) {
                        value.push({
                            name: url.name,
                            url: url.url,
                        });
                    }
                }
            }
            else if (field.type === 'FILE' && field.files) {
                value = [];
                for (const file of (_b = field.files) !== null && _b !== void 0 ? _b : []) {
                    if (file && file.name && file.url) {
                        value.push({
                            name: file.name,
                            url: file.url,
                        });
                    }
                }
            }
            else if ('value' in field)
                value = (_c = field.value) !== null && _c !== void 0 ? _c : '';
            properties.push(new FeatureProperty(`${name}  (${type})`, value));
        }
        return properties;
    }
    /**
     * Get coordinates
     *
     * @param annotation
     * @param altitudeMap
     */
    extractCoordinates(annotation, altitudeMap) {
        const altitudes = [];
        const coordinates = annotation.annotation3d.positions.map((vertex) => {
            const cartograhpic = Ellipsoid.WGS_84.cartographicForPosition(vertex);
            altitudes.push(cartograhpic.height);
            return new Coordinate((180 * cartograhpic.latitude) / Math.PI, (180 * cartograhpic.longitude) / Math.PI);
        });
        altitudeMap.set(annotation.id, altitudes);
        return coordinates;
    }
    /**
     * Get geo json file
     *
     * @param annotations
     */
    read(annotations) {
        return __awaiter(this, void 0, void 0, function* () {
            const features = new FeatureCollection();
            const altitudeMap = new Map();
            for (const annotation of annotations) {
                const properties = yield this.extractFeatureProperties(annotation);
                const coordinates = yield this.extractCoordinates(annotation, altitudeMap);
                // Get geometry
                switch (annotation.annotation3d.shapeType) {
                    case 'POINT': {
                        const geometry = new Point(coordinates[0], annotation.id);
                        geometry.featureProperties.push(...properties);
                        features.geometries.push(geometry);
                        break;
                    }
                    case 'POLYLINE': {
                        const geometry = new LineString(annotation.id);
                        geometry.coordinates.push(...coordinates);
                        geometry.featureProperties.push(...properties);
                        features.geometries.push(geometry);
                        break;
                    }
                    case 'POLYGON': {
                        const geometry = new Polygon(annotation.id);
                        geometry.coordinates.push(...coordinates);
                        geometry.coordinates.push(coordinates[0]);
                        geometry.featureProperties.push(...properties);
                        features.geometries.push(geometry);
                        break;
                    }
                }
            }
            // Add altitude to geometry coordinates
            const json = JSON.parse(Geojson.create(features));
            for (const feature of json['features']) {
                const altitudes = altitudeMap.get(feature['id']);
                if (!altitudes)
                    continue;
                switch (feature['geometry']['type']) {
                    case 'Polygon':
                        feature['geometry']['coordinates'][0].forEach((coordinate, index) => {
                            coordinate.push(altitudes[index % altitudes.length]);
                        });
                        break;
                    case 'LineString':
                        feature['geometry']['coordinates'].forEach((coordinate, index) => {
                            coordinate.push(altitudes[index]);
                        });
                        break;
                    case 'Point':
                        feature['geometry']['coordinates'].push(altitudes[0]);
                        break;
                }
            }
            return json;
        });
    }
}
export default GeoJsonExporter;
